module.exports = __webpack_public_path__ + "16_hair_black.49d5e453.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/16_hair_black.png
// module id = f8ND
// module chunks = 0